
import { RoleInputFilter } from "domain/models/role-input-filter";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useRoleByFilter } from "presentation/hooks/use-query-role";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useEffect } from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import ExpenseGrid from "presentation/components/Expense/ExpenseGrid";
import ExpenseAdmin from "presentation/components/Expense/ExpenseAdmin";

const ExpensePage = () => {
  const rolesAllowedAdmin = ["CEO", "Finanças", "Admin"];

  const [isAdminEnabled, setIsAdminEnabled] = React.useState(false);

  const { isLoading } = usePermissionCheck({ requiredFunction: "expenses" });
  const { userPermissions } = useAuthStore();

  const { data: rolesData } = useRoleByFilter({
    limit: 100,
  } as RoleInputFilter);

  useEffect(() => {
    const rolesAdminSelected = rolesData?.data?.filter((role) =>
      rolesAllowedAdmin.includes(role.name)
    );
    const adminPermissions = userPermissions?.filter((permission) =>
      rolesAdminSelected?.some((role) => role.id === permission.roleId)
    );
    const hasAdminPermission = adminPermissions && adminPermissions.length > 0;
    setIsAdminEnabled(hasAdminPermission ?? false);

    // ------------------------------------------

  }, [rolesData]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title="Despesas" />
      <TabView>
        {(
          <TabPanel header="Despesas" leftIcon="pi pi-euro mr-2">
            <ExpenseGrid hideAddExpense={false} />
          </TabPanel>
        )}
        {isAdminEnabled && (
          <TabPanel header="Administração" leftIcon="pi pi-cog mr-2">
            <ExpenseAdmin />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
};

export default ExpensePage;
